import Vue from 'vue';

export default {
    addVehicle(payload) {
        const path = 'vehicles/add';
        return Vue.axios.post(path, payload);
    },
    getAll(customerId) {
        const path = `vehicles/${customerId}`;
        return Vue.axios.get(path);
    },
    getVehicle(vehicleId) {
        const path = `vehicles/details/${vehicleId}`;
        return Vue.axios.get(path);
    },
    getVehiclePrice({ vehicleId }) {
        const path = `vehicles/price/${vehicleId}`;
        return Vue.axios.get(path);
    },
    removeVehicle({ customerId, vehicleId }) {
        const path = `vehicles/remove`;
        const payload = { customerId, vehicleId };
        return Vue.axios.post(path, payload);
    },
};
